export function ArraysAreEquivalent(arr1, arr2) {
  if ((Array.isArray(arr1) == false || Array.isArray(arr2) == false) && arr1.length != arr2.length) {
    return false
  }

  var arr_1 = [...arr1]
  var arr_2 = [...arr2]
  arr_1.sort()
  arr_2.sort()

  for (var i = 0; i < arr_1.length; i++) {
    if (arr_1[i] != arr_2[i]) {
      return false
    }
  }

  // arrays are equivalent
  return true
}

export function sortByKey(array, key) {
  return array.sort(function (a, b) {
    const x = a[key]
    const y = b[key]
    return x < y ? -1 : x > y ? 1 : 0
  })
}

export function isInt(n) {
  return Number(n) === n && n % 1 === 0
}

export function isFloat(n) {
  return Number(n) === n && n % 1 !== 0
}

export function isOdd(n) {
  return Number(n) % 2 === 1
}
